<script lang="ts">
	import type { ISbStoryData } from '@storyblok/js';
	import type { SbImage } from '../types';
	import { editable } from '../editable';

	interface Props {
		content: ISbStoryData<{
			logo: SbImage;
			quote: string;
			author: string;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<div use:editable={content} class="text-brown-2">
	{#if content.logo.filename}
		<img
			loading="lazy"
			class="h-6"
			src={content.logo.filename}
			alt={content.logo.alt ?? ''}
			title={content.logo.title ?? ''}
		/>
	{/if}
	<blockquote class="mt-6">
		<p class="text-[20px]/[140%]">
			“{content.quote}”
		</p>
		{#if content.author}
			<footer class="mt-3 font-serif text-[16px]/[130%]">— {content.author}</footer>
		{/if}
	</blockquote>
</div>
